import dayjs from "dayjs";
import { useLoaderData, useParams } from "react-router-dom";
import { doFetch } from "../../utils/doFetch";
import { UsageResults } from "./UsageResults";
import { IUsageResultsData } from "./UsageResultsData";

export const usageResultsRouteLoader = async ({ request, params }: { request: any, params: any }) =>
  doFetch(
    `my-profile-usage`,
    { signal: request.signal },
    true,
    true,
    { startDate: params.startDate, endDate: params.endDate },
  )


export const UsageResultsRoute = () => {
  const data = useLoaderData() as IUsageResultsData;
  const params = useParams();
  const { startDate, endDate } = params;
  const dateFormat = 'MMM DD, YYYY';

  const formattedDate = (date: string | undefined): string => {
    const format = 'DD.MM.YYYY';
    return date ? dayjs(date, format).format(dateFormat) : ''
  }

  return (
    <UsageResults startDate={formattedDate(startDate)} endDate={formattedDate(endDate)} data={data} />
  )
}